<template lang="pug">
section#v-faq.container
  h2 FAQ
  h3 1.如何索取活動發票？
  p
    | 發票請於活動當日領取。如有報帳需求，請於結帳流程中填寫公司名稱及統一編號。活動結束後如欲更改發票，請於 7 天內（包含活動當日及例假日）撥打電話
    |
    a(href='tel:0287715865;ext=187') 02-87715865 #187
    |
    | 並來信
    |
    a(href='mailto:service@techorange.com') service@techorange.com
    | ，逾期恕不辦理。
  h3 2. 如何申請退費？
  p 活動舉辦日十天以前，請直接向 KKTIX 申請退票，退票需酌收票面金額 10% 手續費，請詳閱 KKTIX 退換票規定。活動舉辦日十天以內欲申請退費者，請最遲於活動前一天來信 service@techorange.com，同時提供姓名、訂單編號、電話及 email 以便辦理，活動主辦方將收取購買票價 20% 作為手續費後辦理退費，逾期恕不辦理。
</template>

<script>
export default {
  name: 'Faq',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-faq
  padding-bottom: 20px
  padding-top: 60px
h2
  +font(42px, white, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 50px
h3
  +font(22px, white, null, .55px, 500)
  margin-bottom: 20px
p
  +font(20px, white, 30px, .5px, null, justify)
  margin-bottom: 40px

@media (max-width: 1023px)
  #v-faq
    padding-bottom: 10px
    padding-top: 30px
  h2
    +font(30px, null, null, .75px)
    margin-bottom: 30px
  h3
    +font(14px, null, null, .35px)
    margin-bottom: 10px
  p
    +font(12px, null, 20px, .3px)
    margin-bottom: 20px
</style>
